import { Controller } from "@hotwired/stimulus";
import { MDCDialog } from "@material/dialog";

export default class extends Controller {
  openModal(e) {
    e.preventDefault();

    fetch(e.currentTarget.dataset.url)
      .then((res) => res.text())
      .then((html) => {
        const container = document.getElementById("modal-form-container");
        container.innerHTML = html;

        requestAnimationFrame(() => {
          // Always create a fresh instance since we replaced the DOM
          this.modal = new MDCDialog(
            document.getElementById("admin-modal-form")
          );

          this.modal.listen("MDCDialog:closed", () => {
            this.modal.destroy();
            container.innerHTML = "";
          });

          this.modal.open();
        });
      });
  }
}

//  Copyright © 2018 by Northwestern University. All Rights Reserved.
